import { lazyWithRetry } from "utils";

export const ReferralIntake = lazyWithRetry(() => import("./containers"));
export { default as ServiceRequest } from "./containers/ServiceRequest";
